export const Z_INDEXES = {
  HEADER: 0,
  OVERLAY: 1000,
  MENU_DROPDOWN: 10,
};
